import { ISearchType } from '@search/offer-search-routes/src';
import { filterCodec2 } from '@search/vtbeco-frontend-core/view/filters/services/codecs/FilterCodec2';
import { ClassifiedFilterCollection } from '../../filters/ClassifiedFilterCollection';
import { supportedClassifiedFilters } from '../../filters/metadata/ClassifiedFilterMetadata';

export function offerSearchPageFilterToRoute(filtersNew: ClassifiedFilterCollection) {
    const newSearchParams = (filterCodec2.serialize(
        filtersNew.getFilters(),
        supportedClassifiedFilters
    ) as unknown) as ISearchType;

    return newSearchParams;
}
